import clsx from 'clsx';
import { Button } from 'components/Button/Button';

export interface ProductTabItem {
  value: string;
  label: string;
}

export const ProductTabs = ({
  items,
  onClickItem,
  activeIndex,
  className,
  buttonClassName,
  isNonPrimaryTabActive,
}: {
  items: any[];
  onClickItem: Function;
  activeIndex: number;
  className?: string;
  buttonClassName?: string;
  isNonPrimaryTabActive?: boolean;
}) => {
  return (
    <div className={`${isNonPrimaryTabActive ? '' : 'lg:w-full'} ${className}`}>
      <div>
        <div
          className={'flex whitespace-nowrap w-full border-b border-blue-grey'}
          style={{ minWidth: 'fit-content' }}>
          {items?.map((item, i) => (
            <div
              key={i}
              className={clsx('relative z-10', {
                'border-b border-primary-button text-primary':
                  activeIndex === i,
                'mr-2 lg:mr-12': i < items.length - 1,
              })}
              style={{
                marginBottom: '-1px',
                borderBottom: activeIndex === i ? '2px solid #626AFF' : '',
              }}>
              <Button
                text
                fluidWidthSlim
                type="button"
                className={`${buttonClassName} ${activeIndex === i ? 'text-primary' : 'text-grey'}`}
                active={activeIndex === i}
                style={{
                  display: 'block',
                  minWidth: '0rem',
                  borderRadius: '0',
                }}
                onClick={() => onClickItem(item)}
                key={i}>
                {item?.label}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
